import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BuyTicketDTO, SummaryBuyDTO } from 'src/app/data/dto/BuyTicketsDTO';
import { UseCase } from '../../base/UserCase';
import { BuyTicketRepository } from '../../repositories/buyTickets/BuyTicketRepository';

@Injectable({
    providedIn: 'root'
})

export class AddBuyTicketUseCase implements UseCase<BuyTicketDTO, SummaryBuyDTO> {
    constructor(
        private buyTicketRepository: BuyTicketRepository,
    ) { }

    execute(params: BuyTicketDTO): Observable<SummaryBuyDTO> {
        return this.buyTicketRepository.addBuyTicket(params);
    }
}
